import { createModel } from "hox";
import React, { useState } from "react"
import { TablePaginationConfig } from "antd/es/table/interface";
import { IBranchSearch, IBranchDetail, IBranchInsert, IBranchUpadata, IBranchParams } from "./dataBranchTypes"
import { branchService } from "./dataBranchService"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { filterArrId, Optios } from "../../../utils/utils"
import { globalPrompt } from "../../../components2/YhMessage"
import { useMdmModel } from "../../../model/mdmModel"

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}
export const useDataBranchModel = createModel(function () {
    const {initBranchData} = useMdmModel()
    const initSearchParams: IBranchParams = {}
    const initDataSource: IBranchDetail[] = []
    const initAddParam: IBranchInsert = {}
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IBranchParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<IBranchDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    //新增参数
    const [addParam, setAddParam] = useState<IBranchInsert>(initAddParam);
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<IBranchDetail>({})
    //下拉框分支数据
    const [selectData, setSelectData] = useState<Optios[]>([])
    const upDataSearchParam = (upDataParam: IBranchParams) => {
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: IBranchParams) => {
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await branchService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        setDataSource(records)
    }
    const loadSelectData = async () => {
        const params = {
            page: {
                pageSize: 1000,
                pageNum: 1
            }
        }
        const { retData } = await branchService.page(params)
        const { records, ...pg } = retData
        const newArr = filterArrId<IBranchDetail>(records)
        setSelectData(newArr)
    }
    const updataAddParam = (updateParam: IBranchDetail) => {
        setAddParam({ ...addParam, ...updateParam })
    }
    const updataEditParam = (uptataParam: IBranchDetail) => {
        setSelectedRow({ ...selectedRow, ...uptataParam })
    }
    const insertDetail = async (params: IBranchInsert) => {
        const { retData, retMsg } = await branchService.insert(params)
        globalPrompt("message", { type: "success", text: retMsg })
        retData&&initBranchData()
        return retData
    }
    const updataDetail = async (params: IBranchUpadata) => {
        const { retData, retMsg } = await branchService.updata(params)
        globalPrompt("message", { type: "success", text: retMsg })
        retData&&initBranchData()
        return retData    
    }
    return {
        searchParam,
        dataSource,
        addParam,
        selectedRowKeys,
        selectedRow,
        page,
        selectData,
        setSearchParam,
        setDataSource,
        setAddParam,
        updataAddParam,
        updataEditParam,
        setSelectedRowKeys,
        setSelectedRow,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        insertDetail,
        updataDetail,
        loadSelectData
    }


});